import { createFolderActionTypes } from './Constants';

export function toggleCreateFolderModal(open) {
	return {
		type: createFolderActionTypes.TOGGLE_CREATE_FOLDER_MODAL,
		payload: {
			open,
		},
	};
}

export function handleCreateFolderModal(options) {
	return {
		type: createFolderActionTypes.HANDLE_CREATE_FOLDER_MODAL,
		payload: {
			options,
		},
	};
}
